import { SafeError, SafePromise } from '@benzinga/safe-await';

import { RestfulClient, Sound } from '@benzinga/session';
import { IncomingAuthorResult, IncomingCategoryResult, IncomingCategoryUpdateResult } from './ingress';
import { Session } from '@benzinga/session';
import { NewsAlertsEnvironment } from './environment';
import { CategoryId } from '@benzinga/advanced-news-manager';
import { UnsubscribeAllKeyResponse } from './entities';

export class NewsAlertsRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(NewsAlertsEnvironment).url, session, { 'x-device-key': true });
  }

  public getCategoriesAlerts = (): SafePromise<IncomingCategoryResult> => {
    const url = this.URL('api/v2/watchlists/channel');
    return this.get(url, { allowsAnonymousAuth: true });
  };

  public setCategoriesAlerts = (
    categoryId: CategoryId,
    sound?: Sound,
    realtimeEmail?: boolean,
  ): SafePromise<IncomingCategoryUpdateResult> => {
    const url = this.URL(`api/v2/watchlists/channel`);
    return this.patch(url, {
      channel_id: categoryId,
      sound,
      subscription_type: realtimeEmail,
    });
  };

  public createAuthorSubscription = (authorId: number, authorName: string): SafePromise<IncomingAuthorResult> => {
    const url = this.URL(`api/v2/watchlists/alerts/type/author`);
    return this.post(url, { alert_name: authorName, author_id: authorId, send_realtime: true });
  };

  public getAuthorSubscriptions = (): SafePromise<IncomingAuthorResult> => {
    const url = this.URL('api/v2/watchlists/alerts/type/author');
    return this.get(url);
  };

  public removeAuthorSubscription = (alertId: number): SafePromise<any> => {
    const url = this.URL(`api/v2/watchlists/alerts/${alertId}`);
    return this.delete(url);
  };

  public getUnsubscribeAllKey = (): SafePromise<UnsubscribeAllKeyResponse> => {
    const url = this.URL('api/v2/watchlists/unsubscribe_key');
    return this.get(url);
  };

  public unsubscribeAllRealtime = async (unsubAllKey: string): SafePromise<void> => {
    const profileUrl = new URL('https://www.benzinga.com/profile/unsubscribe');
    profileUrl.searchParams.set('key', unsubAllKey);
    profileUrl.searchParams.set('type', 'realtime');
    profileUrl.searchParams.set('scope', 'all');
    const response = await this.getRaw(profileUrl);
    if (response.err) {
      return response;
    }
    if (!response.ok.ok) {
      return {
        err: new SafeError(`Unsubscribe failed: HTTP ${response.ok.status}`, 'unsubscribe_all_realtime_http'),
      };
    }
    return { ok: undefined };
  };
}
